import { Box, Skeleton, Typography } from '@mui/material'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import PActionButton from './PActionButton'

const PActiveList = ({ staffId, appraisalData, isLoading, hasRoles }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const viewHandler = (item) => {
    navigate(`${location.pathname}/${item.appraisal_id}`, {
      state: {
        item,
        hasRoles,
        staffId,
        isActive: true,
      },
    })
  }

  const formatCourseDate = (date) => {
    const dateObj = new Date(date + 'T00:00:00')
    return new Intl.DateTimeFormat('en-GB').format(dateObj)
  }

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" marginBottom={3}>
        Active
      </Typography>
      <PActionButton
        onClick={() => viewHandler(appraisalData[0] ?? [])}
        title={isLoading ? '...' : appraisalData[0]?.appraisal_label}
        status={isLoading ? '...' : appraisalData[0]?.appraisal_status}
        start_date={
          appraisalData[0]?.start_date ? formatCourseDate(appraisalData[0]?.start_date) : '...'
        }
        end_date={appraisalData[0]?.due_date ? formatCourseDate(appraisalData[0]?.due_date) : '...'}
        progress={
          (appraisalData[0]?.completed_submission / appraisalData[0]?.total_submission) * 100
        }
        completedSub={appraisalData[0]?.completed_submission}
        totalSub={appraisalData[0]?.total_submission}
      />
    </Box>
  )
}

export default PActiveList
